import apiFetch from '../apiFetch'
export default function () {

  return apiFetch({endPoint: `Pool`, method: 'GET', body: null})
}
